import React from 'react'
import { navigate } from 'gatsby'
import { Avatar } from '@chakra-ui/react'
import { Tooltip } from '@chakra-ui/react'
import { Box, Text, Link } from '@chakra-ui/react'

import {
    formatEmail,
    getAddressStrings,
    getClientFullName,
} from '~utils/helpers'
import { ChatFieldsFragment } from '~graphql/generated/graphql'
import SharedStack from '~components/shared/wrappers/shared-stack'
import ClickToCopyText from '~components/shared/modals/appointment-details/click-to-copy'
import { UserRoutes } from '~config/routes'

interface Props {
    chat: ChatFieldsFragment
}

export default function ChatClientDetails({ chat }: Props) {
    const { client } = chat

    return (
        <Box py={4} px={5}>
            <SharedStack spacing={4}>
                <SharedStack row spaced mb={2}>
                    <Tooltip label="View more details" hasArrow>
                        <Text
                            as={Link}
                            onClick={() => {
                                navigate(
                                    UserRoutes.ChatConversation(chat.id) +
                                        `&client=${client.id}`,
                                )
                            }}
                            fontWeight="medium"
                            fontSize="md"
                        >
                            {getClientFullName(client)}
                        </Text>
                    </Tooltip>
                    <Avatar
                        src={''}
                        name={getClientFullName(client) || ''}
                        size="xs"
                    />
                </SharedStack>
                <InfoItem label="Email">
                    <CopiableInfoText>
                        {formatEmail(client?.email)}
                    </CopiableInfoText>
                </InfoItem>
                <InfoItem label="Address">
                    {client?.address && client?.address?.street_a ? (
                        <CopiableInfoText>
                            {getAddressStrings(client?.address).map(
                                (address, index) => (
                                    <InfoText key={index}>{address}</InfoText>
                                ),
                            )}
                        </CopiableInfoText>
                    ) : (
                        <InfoText />
                    )}
                </InfoItem>
            </SharedStack>
        </Box>
    )
}

export function InfoItem({
    label,
    children,
}: {
    label: string
    children: React.ReactNode
}) {
    return (
        <SharedStack row align="flex-start" spaced>
            <Box flex={1}>
                <Text fontWeight="normal" fontSize="xs" color="gray.600">
                    {label}
                </Text>
            </Box>
            <Box flex={2}>{children}</Box>
        </SharedStack>
    )
}

export function InfoText({ children }: { children?: React.ReactNode }) {
    return (
        <Text fontWeight="normal" fontSize="xs" color="gray.900">
            {children || '-'}
        </Text>
    )
}

export function CopiableInfoText({ children }: { children: React.ReactNode }) {
    return (
        <ClickToCopyText fontWeight="normal" fontSize="xs" color="gray.900">
            {children}
        </ClickToCopyText>
    )
}
